module.exports = __webpack_public_path__ + "static/pakmaya-digital-marketing-2f89a186dcec1db84fb78b08c232a6c3.png";